import { apiClient } from '@app/lib'
import { type SugarProviderProfileUpdate, SugarProviderProfileUpdateResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

export const useUpdateProviderProfile = () => {
  const queryClient = useQueryClient()
  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (input: SugarProviderProfileUpdate) => {
      try {
        const { data } = await apiClient.put<SugarProviderProfileUpdateResponse>('/api/provider-profile', input)

        return data
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.data) {
          return err.response.data as SugarProviderProfileUpdateResponse
        }

        throw err
      }
    },
    onSuccess: ({ data, success }, { siteId }) => {
      if (success && data) queryClient.setQueryData(['provider-profile', { siteId }], data)
    }
  })

  return {
    isUpdatingProviderProfile: isPending,
    updateProviderProfile: mutateAsync
  }
}
